import { render, staticRenderFns } from "./ApplyDocStatistics.vue?vue&type=template&id=4d3a87a9&"
import script from "./ApplyDocStatistics.vue?vue&type=script&lang=js&"
export * from "./ApplyDocStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ApplyDocStatistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports